import api from './api'

/**
 * Serviço de Integrações/Conectores (TENANT_ADMIN)
 * 
 * Backend: /api/tenant/integrations
 */
export default {
  /**
   * Listar conectores com status
   * GET /api/tenant/integrations
   */
  list() {
    return api.get('/api/tenant/integrations')
  },

  /**
   * Conectar integração
   * POST /api/tenant/integrations/{id}/connect
   */
  connect(connectorId, credentials) {
    return api.post(`/api/tenant/integrations/${connectorId}/connect`, credentials)
  },

  /**
   * Desconectar integração
   * POST /api/tenant/integrations/{id}/disconnect
   */
  disconnect(connectorId) {
    return api.post(`/api/tenant/integrations/${connectorId}/disconnect`)
  },

  /**
   * Testar conexão
   * POST /api/tenant/integrations/{id}/test
   */
  test(connectorId) {
    return api.post(`/api/tenant/integrations/${connectorId}/test`)
  },

  // ===== GitHub Integration (OAuth Flow) =====

  /**
   * Iniciar instalação do GitHub App (criar integração pendente)
   * POST /api/integrations/github/installation-init
   */
  initGithubInstallation(accountLogin, accountId) {
    return api.post('/api/integrations/github/installation-init', {
      accountLogin,
      accountId: accountId ? String(accountId) : null
    })
  },

  /**
   * Reconectar GitHub (para integrações com status DELETED)
   * POST /api/integrations/github/reconnect
   */
  reconnectGithub(accountLogin, accountId) {
    return api.post('/api/integrations/github/reconnect', {
      accountLogin,
      accountId: accountId ? String(accountId) : null
    })
  },

  /**
   * Obter URL de instalação do GitHub App
   * GET /api/integrations/github/install
   */
  getGithubInstallUrl() {
    return api.get('/api/integrations/github/install')
  },

  /**
   * Verificar status da integração GitHub
   * GET /api/integrations/github/status
   */
  getGithubStatus() {
    return api.get('/api/integrations/github/status')
  },

  /**
   * Desconectar GitHub
   * DELETE /api/integrations/github/disconnect
   */
  disconnectGithub() {
    return api.delete('/api/integrations/github/disconnect')
  },

  /**
   * Listar repositórios do GitHub
   * GET /api/integrations/github/repositories
   */
  getGithubRepositories() {
    return api.get('/api/integrations/github/repositories')
  },

  // ===== Jira Integration (OAuth 2.0 Flow) =====

  /**
   * Obter URL de autorização OAuth 2.0 do Jira
   * GET /api/integrations/jira/connect?tenantId={tenantId}
   * Retorna: { authUrl: "https://auth.atlassian.com/authorize?..." }
   */
  getJiraConnectUrl(tenantId) {
    return api.get(`/api/integrations/jira/connect?tenantId=${tenantId}`)
  },

  /**
   * Verificar status da integração Jira
   * GET /api/integrations/jira/status/{tenantId}
   */
  getJiraStatus(tenantId) {
    return api.get(`/api/integrations/jira/status/${tenantId}`)
  },

  /**
   * Desconectar Jira
   * DELETE /api/tenants/{tenantId}/integrations/jira
   */
  disconnectJira(tenantId) {
    return api.delete(`/api/tenants/${tenantId}/integrations/jira`)
  },

  // ===== Microsoft / Azure DevOps Integration (OAuth 2.0 Flow) =====

  /**
   * Obter URL de autorização OAuth 2.0 da Microsoft
   * GET /api/integrations/microsoft/connect
   * Retorna: { authUrl: "https://login.microsoftonline.com/..." }
   */
  getMicrosoftConnectUrl() {
    return api.get('/api/integrations/microsoft/connect')
  },

  /**
   * Verificar status da integração Microsoft
   * GET /api/integrations/microsoft/status
   * Retorna: { connected: true/false, userEmail: "...", displayName: "..." }
   */
  getMicrosoftStatus() {
    return api.get('/api/integrations/microsoft/status')
  },

  /**
   * Desconectar Microsoft
   * DELETE /api/integrations/microsoft/disconnect
   */
  disconnectMicrosoft() {
    return api.delete('/api/integrations/microsoft/disconnect')
  },
}
